import {AxiosResponse} from 'axios'
import {corporateApi} from '../../../../setup/axios/CorporateApi'
import {ApiResponse, PageResponse} from '../../../../shared/models/ApiModels'
import {IInterviewCreateRequest, IInterviewFilters, IInterviewModel, IInterviewNote} from './InterviewModel'

const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')
const INTERVIEW_URL = `${API_URL}api/v1/interview/`

export function createInterview(request: IInterviewCreateRequest): Promise<AxiosResponse<ApiResponse<IInterviewModel>>> {
  return corporateApi.post(`${INTERVIEW_URL}create`, request)
}

export function searchInterviews(
  filters: IInterviewFilters,
  page = 0,
  size = 10
): Promise<AxiosResponse<ApiResponse<PageResponse<IInterviewModel>>>> {
  const params: Record<string, string | number> = {page, size, sort: 'startDateTime,desc'}
  if (filters.q) params.q = filters.q
  if (filters.status) params.status = filters.status
  if (filters.from) params.from = filters.from
  if (filters.to) params.to = filters.to
  return corporateApi.get(`${INTERVIEW_URL}search`, {params})
}

export function getInterview(id: string): Promise<AxiosResponse<ApiResponse<IInterviewModel>>> {
  return corporateApi.get(`${INTERVIEW_URL}getById/${id}`)
}

export function getCandidateInterviews(candidateId: string): Promise<AxiosResponse<ApiResponse<IInterviewModel[]>>> {
  return corporateApi.get(`${INTERVIEW_URL}candidate/${candidateId}`)
}

export function addInterviewNote(id: string, text: string): Promise<AxiosResponse<ApiResponse<IInterviewNote>>> {
  return corporateApi.post(`${INTERVIEW_URL}${id}/notes`, {text})
}

export function completeInterview(
  id: string,
  completedAt: string | null,
  note: string | null
): Promise<AxiosResponse<ApiResponse<IInterviewModel>>> {
  return corporateApi.post(`${INTERVIEW_URL}${id}/complete`, {completedAt, note})
}

export function cancelInterview(id: string, reason: string): Promise<AxiosResponse<ApiResponse<IInterviewModel>>> {
  return corporateApi.post(`${INTERVIEW_URL}${id}/cancel`, {reason})
}
